<template>
  <div id="emailTemplateModule">
    <v-layout row>
      <v-flex class="xs12 sm12">
        <v-btn fab absolute left to="dashboard" class="ml-2 pf-btn-fab">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <p class="ml-2 mb-0 mt-70 pf-font-20">
      URL: <a :href="getFamilyURL" v-if="getFamilyURL" target="_blank">{{ getFamilyURL }}</a>
      <span v-else>Not found</span>
    </p>
    <template v-if="WebsiteTemplate.length">
      <div class="ma-2">
          <!-- <div class="pf-font-18 mt-4 mb-3">{{ WebsiteTemplate[0].name }}</div> -->
          <v-layout class="mb-2 ml-2 flex-start">
              <v-btn class="pf-btn ml-0 pf-btn-text-white pf-bg-green" @click="saveCustomColors" :disabled="!selectedData">
                <v-icon size="16" class="pr-1">file_copy</v-icon>
                <div class="pf-text-center">Save</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="resetToDefault" v-if="Account.custom_website_colors && Object.keys(Account.custom_website_colors).length">
                <v-icon size="16" class="pr-1">history</v-icon>
                <div class="pf-text-center">Reset To Default</div>
              </v-btn>
          </v-layout>
          <template v-if="customColors && Object.keys(customColors).length">
            <v-layout wrap class="mb-2">
              <v-flex xs6 sm2 class="mt-2 pr-4">
                <span class="mb-3 custom-title">Menu</span>
                <v-btn block :color="customColors.primary_color" @click="pickPrimaryColor = !pickPrimaryColor"></v-btn>
                <chrome-picker :value="customColors.primary_color" @input="changeCustomColor($event, 'primary_color')" v-if="pickPrimaryColor"></chrome-picker>
              </v-flex>
              <v-flex xs6 sm2 class="mt-2 pr-4">
                <span class="mb-3 custom-title">Footer</span>
                <v-btn block :color="customColors.secondary_color" @click="pickSecondaryColor = !pickSecondaryColor"></v-btn>
                <chrome-picker :value="customColors.secondary_color" @input="changeCustomColor($event, 'secondary_color')" v-if="pickSecondaryColor"></chrome-picker>
              </v-flex>
              <v-flex xs6 sm2 class="mt-2 pr-4">
                <span class="mb-3 custom-title">Banner text color</span>
                <v-btn block :color="customColors.tertiary_color" @click="pickTertiaryColor = !pickTertiaryColor"></v-btn>
                <chrome-picker :value="customColors.tertiary_color" @input="changeCustomColor($event, 'tertiary_color')" v-if="pickTertiaryColor"></chrome-picker>
              </v-flex>
              <v-flex xs6 sm2 class="mt-2 pr-4">
                <span class="mb-3 custom-title">Banner text</span>
                <v-btn block :color="customColors.quaternary_color" @click="pickQuaternaryColor = !pickQuaternaryColor"></v-btn>
                <chrome-picker :value="customColors.quaternary_color" @input="changeCustomColor($event, 'quaternary_color')" v-if="pickQuaternaryColor"></chrome-picker>
              </v-flex>
              <v-flex xs6 sm2 class="mt-2 pr-4">
                <span class="mb-3 custom-title">Main</span>
                <v-btn block :color="customColors.background_color" @click="pickBackgroundColor = !pickBackgroundColor"></v-btn>
                <chrome-picker :value="customColors.background_color" @input="changeCustomColor($event, 'background_color')" v-if="pickBackgroundColor"></chrome-picker>
              </v-flex>
            </v-layout>
          </template>
          <iframe height="500" width="100%" :src="`${getFamilyURL}?${getThemeString(WebsiteTemplate[0], Account.custom_website_colors && Object.keys(Account.custom_website_colors).length)}`" class="pf-border-dark-1"></iframe>

      </div>
    </template>
    <v-layout v-else>
      <h5 class="no-data-text">No website templates found. Please check with your agency</h5>
    </v-layout>

    <!-- Modals -->
    <!-- <app-modal :active="chooseCustomColors" v-if="chooseCustomColors" width="60%">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <v-btn class="pf-modal-close" icon dark @click="colseCustomColors">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Choose Custom Colors</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <p class="ml-4">Choose your custom colors below</p>
            <v-layout wrap class="pb-4 pl-4">
                <v-flex xs12 sm6 class="mt-4 pr-4">
                    <span class="pf-sub-head mb-3 custom-title">Menu background</span>
                    <v-btn block :color="customColors.primary_color" @click="pickPrimaryColor = !pickPrimaryColor"></v-btn>
                    <chrome-picker :value="customColors.primary_color" @input="changeCustomColor($event, 'primary_color')" v-if="pickPrimaryColor"></chrome-picker>
                </v-flex>
                <v-flex xs12 sm6 class="mt-4 pr-4">
                    <span class="pf-sub-head mb-3 custom-title">Footer background</span>
                    <v-btn block :color="customColors.secondary_color" @click="pickSecondaryColor = !pickSecondaryColor"></v-btn>
                    <chrome-picker :value="customColors.secondary_color" @input="changeCustomColor($event, 'secondary_color')" v-if="pickSecondaryColor"></chrome-picker>
                </v-flex>
                <v-flex xs12 sm6 class="mt-4 pr-4">
                    <span class="pf-sub-head mb-3 custom-title">Banner text color</span>
                    <v-btn block :color="customColors.tertiary_color" @click="pickTertiaryColor = !pickTertiaryColor"></v-btn>
                    <chrome-picker :value="customColors.tertiary_color" @input="changeCustomColor($event, 'tertiary_color')" v-if="pickTertiaryColor"></chrome-picker>
                </v-flex>
                <v-flex xs12 sm6 class="mt-4 pr-4">
                    <span class="pf-sub-head mb-3 custom-title">Banner text background</span>
                    <v-btn block :color="customColors.quaternary_color" @click="pickQuaternaryColor = !pickQuaternaryColor"></v-btn>
                    <chrome-picker :value="customColors.quaternary_color" @input="changeCustomColor($event, 'quaternary_color')" v-if="pickQuaternaryColor"></chrome-picker>
                </v-flex>
                <v-flex xs12 sm6 class="mt-4 pr-4">
                    <span class="pf-sub-head mb-3 custom-title">Main background</span>
                    <v-btn block :color="customColors.background_color" @click="pickBackgroundColor = !pickBackgroundColor"></v-btn>
                    <chrome-picker :value="customColors.background_color" @input="changeCustomColor($event, 'background_color')" v-if="pickBackgroundColor"></chrome-picker>
                </v-flex>
            </v-layout>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="pf-btn-text-white pf-bg-green"
              @click="saveCustomColors"
              :disabled="!selectedData"
            >
              Save
            </v-btn>
            <v-btn
              class="pf-btn-text-white pf-bg-pink"
              @click="colseCustomColors"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-modal> -->

  </div>
</template>
<script>
/* global session store config */
import swal from 'sweetalert2';
import { getCollection, update, getOne } from '../../helpers/helpers';
import { Chrome } from 'vue-color';
// import AppModal from '../../components/AppModal';
// import WebsiteTemplatePreview from '../../pages/WebsiteTemplate/template';

export default {
  name: 'WebsiteTemplate',
  components: {
    // 'template-preview': WebsiteTemplatePreview,
    'chrome-picker': Chrome,
    // 'app-modal': AppModal
  },
  data: () => ({
    config: config,
    // panelExpand: [],
    noOfPanels: 0,
    defaultLetter: null,
    defaultVideo: null,
    albumPhotos: [],
    blogs: [],
    agency: null,
    chooseCustomColors: false,
    customColors: null,
    pickPrimaryColor: false,
    pickSecondaryColor: false,
    pickTertiaryColor: false,
    pickQuaternaryColor: false,
    pickBackgroundColor: false,
    colorPickIndex: -1,
    selectedData: false
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    WebsiteTemplate: {
      get () {
        return store.state.WebsiteTemplate;
      },
      set (value) {
        store.commit('setWebsiteTemplate', value);
      }
    },
    Account: {
      get () {
        return store.state.Account;
      },
      set (value) {
        store.commit('setAccount', value);
      }
    },
    getFamilyURL () {
      /* eslint-disable */
      let URL = this.Account.contactInfo && this.Account.contactInfo.website ? this.Account.contactInfo.website : (this.Account.nickname ? config.WPParams.host + 'profile/' + this.Account.nickname : null);
      return URL ? (URL.indexOf('http') > -1 ? URL : ('https://' + URL)) : null;
    }
  },
  async created () {
    /* Not allowed for Network members */
    if (!this.Account.membership || this.Account.membership === 'Network') {
      this.$router.push({ path: `/` });
    }
    await this.getWebsiteTemplates();
    /* Set the selected template panel to expand by default */
    // await this.setTemplateExpand();

    if (session.role() === 'parent') {

      /* Set the customColors is already set */
      if (this.Account.custom_website_colors && Object.keys(this.Account.custom_website_colors).length) {
        this.customColors = this.Account.custom_website_colors;
      } else if (this.Account.website_template) {
        let selectedIndex = this.WebsiteTemplate.findIndex(x => x.id === this.Account.website_template);
        if (selectedIndex > -1) {
          this.customColors = {
            primary_color: this.WebsiteTemplate[selectedIndex].primary_color,
            secondary_color: this.WebsiteTemplate[selectedIndex].secondary_color,
            tertiary_color: this.WebsiteTemplate[selectedIndex].tertiary_color,
            quaternary_color: this.WebsiteTemplate[selectedIndex].quaternary_color,
            background_color: this.WebsiteTemplate[selectedIndex].background_color
          };
        }
      } else {
        /* This handles in the value is {} */
        this.customColors = null;
      }

      /* Fetch the default album if exists */
      if (this.Account && this.Account.default_letter) {
        await this.fetchDefaultLetter(); 
      }
      /* Fetch 10 album photos */
      if (this.Account.album && this.Account.album.length) {
        await this.fetchAlbumPhotos(); 
      }
      /* Fetch the default video if exists */
      if (this.Account && this.Account.default_video) {
        await this.fetchDefaultVideo(); 
      }
      /* Fetch 10 album photos */
      if (this.Account.blog && this.Account.blog.length) {
        await this.fetchBlogs(); 
      }
      /* Fetch default agency data */
      await this.fetchAgency(); 
    }
  },
  methods: {
    getThemeString (template, isSelectedAndCustom = false) {
      if (isSelectedAndCustom && this.customColors) {
        template = this.customColors;
      }
      let queryString = '';
      queryString += template.primary_color ? `menu_bg=${template.primary_color.replace('#', '')}` : null;
      queryString += template.secondary_color ? `&footer_bg=${template.secondary_color.replace('#', '')}` : null;
      queryString += template.tertiary_color ? `&banner_text_color=${template.tertiary_color.replace('#', '')}` : null;
      queryString += template.quaternary_color ? `&banner_text_bg=${template.quaternary_color.replace('#', '')}` : null;
      queryString += template.background_color ? `&main_bg=${template.background_color.replace('#', '')}` : null;
      return queryString;
    },
    // async setTemplateExpand () {
    //   if (this.WebsiteTemplate.length) {
    //     this.noOfPanels = this.WebsiteTemplate.length;
    //     if (this.Account.website_template) {
    //       this.panelExpand = this.WebsiteTemplate.map(x => x.id === this.Account.website_template);
    //     } else {
    //       /* Expand the first one */
    //       this.panelExpand = this.WebsiteTemplate.map((x, i) => i === 0);
    //     }
    //   }
    // },
    async chooseTemplate (template, isResetToDefault = false) {
      if (template && template.id) {

        /* Remove the custom_website_colors if reset to default */
        if (isResetToDefault) {
          this.Account.custom_website_colors = {};
        }
        this.Account.website_template = template.id;
        this.Account.updated_from = 'websiteTemplate';
        let { error, data } = await update('Account', this.Account, this.Account.id);

        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to update the data'
          };
        } else {
          this.Account = this.Account;
          // this.setTemplateExpand();

          /* Update the customColors */
          let selectedIndex = this.WebsiteTemplate.findIndex(x => x.id === this.Account.website_template);
          if (selectedIndex > -1) {
            this.customColors = {
              primary_color: this.WebsiteTemplate[selectedIndex].primary_color,
              secondary_color: this.WebsiteTemplate[selectedIndex].secondary_color,
              tertiary_color: this.WebsiteTemplate[selectedIndex].tertiary_color,
              quaternary_color: this.WebsiteTemplate[selectedIndex].quaternary_color,
              background_color: this.WebsiteTemplate[selectedIndex].background_color
            };
          }

          swal.fire({
            type: 'success',
            title: 'Website template updated',
            text: `Your website template was ${ isResetToDefault ? 'reset to default' : 'submitted' } successfully.`,
            showConfirmButton: true,
            timer: 2500,
            onClose: () => {
              return;
            }
          });
          return;
        }
      }
    },
    async getWebsiteTemplates () {
      if (!this.WebsiteTemplate.length) {
        let entity = `WebsiteTemplate`;
        let { error, data } = await getCollection(entity, true, 0);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.WebsiteTemplate = data;
          }
        }
      }
    },
    // openCustomColors (template) {
    //   this.chooseCustomColors = true;
    //   /* Set the customColors if not set already */
    //   if (!this.customColors) {
    //     this.customColors = {
    //       primary_color: template.primary_color,
    //       secondary_color: template.secondary_color,
    //       tertiary_color: template.tertiary_color,
    //       quaternary_color: template.quaternary_color,
    //       background_color: template.background_color
    //     };
    //   }
    // },
    resetToDefault () {
      let self = this;
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, reset it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            if (self.Account.website_template) {
              /* Choose the template again, it'll update the WP data */
              await self.chooseTemplate({ id: self.Account.website_template }, true);
            } else {
              swal.fire({
                type: 'warning',
                title: 'Not found',
                text: 'It seems like you don\'t have template selected, please select one',
                showConfirmButton: true,
                onClose: () => {
                  // 
                }
              });
              return;
            }
          })();
        }
      });
    },
    /* colseCustomColors () {
      this.chooseCustomColors = false;
      if (this.Account.custom_website_colors && Object.keys(this.Account.custom_website_colors).length) {
        this.customColors = this.Account.custom_website_colors;
      } else {
        this.customColors = null;
      }
    }, */
    changeCustomColor (newColor, type) {
      this.customColors[type] = newColor.hex8;
      this.selectedData = true;
    },
    async saveCustomColors () {
      this.selectedData = false;
      this.Account.custom_website_colors = this.customColors;
      this.Account.updated_from = 'websiteTemplate';
      let { error, data, status } = await update('Account', this.Account, this.Account.id);
      if (error) {
        console.log('error', error);
        this.selectedData = true;
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to save the colors, please try again.'
        };
      } else {
        swal.fire({
          type: 'success',
          title: 'Your custom template colors were updated successfully',
          showConfirmButton: false,
          timer: 2500
        });
        this.chooseCustomColors = false;
      }
      this.pickPrimaryColor = this.pickSecondaryColor = this.pickTertiaryColor = this.pickQuaternaryColor = false;
    },
    async fetchDefaultLetter () {
      let { error, data } = await getOne('Letter', this.Account.default_letter, '', 'description');
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to fetch the default letter'
        };
      } else {
        this.defaultLetter = data;
      }
    },
    async fetchDefaultVideo () {
      let { error, data } = await getOne('Video', this.Account.default_video, '', 'url,type');
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to fetch the profile video'
        };
      } else {
        this.defaultVideo = data;
      }
    },
    async fetchAlbumPhotos () {
      let where = { account: this.Account.id };
      let attributes = 'original_url,thumb_url,webview_url';
      let { error, data } = await getCollection('Photo', false, 8, '', where, attributes);
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to fetch the album photos'
        };
      } else {
        this.albumPhotos = data;
      }
    },
    async fetchBlogs () {
      let where = { account: this.Account.id };
      let attributes = 'title,content,image';
      let { error, data } = await getCollection('Blog', false, 3, '', where, attributes);
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to fetch the blogs'
        };
      } else {
        this.blogs = data;
      }
    },
    async fetchAgency () {
      if (this.Account.default_agency || (this.Account.agency && this.Account.agency.length)) {
        let agencyId = this.Account.default_agency ? this.Account.default_agency : (this.Account.agency[0] && this.Account.agency[0].agency ? this.Account.agency[0].agency : null);
        if (!agencyId) {
          return;
        }
        let attributes = 'name,address,phone,email,website';
        let populate = { path: 'state', select: 'name' };
        let { error, data } = await getOne('Agency', agencyId, populate, attributes);
        if (error) {
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to fetch the blogs'
          };
        } else {
          this.agency = data;
        }
      }
    }
  }
};
</script>
<style scoped>
  .pf-small-box {
    width: 100%;
    height: 40px;
  }
  .vc-chrome {
    position: absolute;
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// src/pages/WebsiteTemplate/list_parent.vue